import { ComponentProps } from 'react';
import { FormattedMessage } from 'react-intl';
import { useExperiments } from '@alltrails/experiments';
import PeakFeatureUpsellModal from '@alltrails/upsell/components/UpsellSystem/FeatureUpsell/PeakFeatureUpsellModal';
import PlusFeatureUpsellModal from '@alltrails/upsell/components/UpsellSystem/FeatureUpsell/PlusFeatureUpsellModal';
import headerImageSrc from './conditions-upsell-header.avif';

type Props = Pick<ComponentProps<typeof PeakFeatureUpsellModal>, 'isOpen' | 'onCloseRequest' | 'upsellTrigger'>;

const ConditionsUpsellModal = (modalProps: Props) => {
  const experiments = useExperiments();

  if (experiments['rm-conditions-plus']?.value === 'on') {
    return (
      <PlusFeatureUpsellModal
        {...modalProps}
        headerImageSrc={headerImageSrc}
        heading={<FormattedMessage defaultMessage="Stay prepared for snow, mud, ice, and more" />}
        promoEligibleHeading={<FormattedMessage defaultMessage="Try Trail Conditions and more for free" />}
      />
    );
  }

  return (
    <PeakFeatureUpsellModal
      {...modalProps}
      headerImageSrc={headerImageSrc}
      heading={<FormattedMessage defaultMessage="Stay prepared for snow, mud, ice, and more" />}
      promoEligibleHeading={<FormattedMessage defaultMessage="Try Trail Conditions and more for free" />}
    />
  );
};

export default ConditionsUpsellModal;
